import * as Case from 'case';
import { Asset } from 'contentful';
import { Model } from '../model';

export class AssetModel extends Model {
  public readonly title: string;
  public readonly description: string;
  public readonly file: Asset['fields']['file'];

  public get contextLabel() {
    return this.title;
  }

  public get contextValue() {
    return Case.kebab(this.file.url);
  }
}
